<template>
  <DragPanel
    ref="dragPanel"
    title="布局"
    class="dragPanel-layout"
    :closePanel="closePanel"
    :limitDragArea="limitDragArea">
    <div class="layout-box">
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          v-model="keywords"
          placeholder="请输入布局名称搜索"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search" />
        </el-input>
      </div>
      <div class="layout-list-box">
        <div class="cad-name-box">
          <div
            :class="`expand-icon-box ${isExpand ? 'expand' : ''}`"
            @click="toggleExpand">
            <i class="el-icon-caret-right" />
          </div>
          <div
            class="name-box dialog-label"
            :title="cadInfo.name">
            {{ cadInfo.name }}
          </div>
        </div>
        <div
          class="list-box"
          v-if="isExpand">
          <div
            :class="`list-item-box dialog-label ${
              currLayout === item ? 'active' : ''
            }`"
            v-for="(item, index) in filterLayoutList"
            :key="index"
            @click="switchLayout(item)">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
export default {
  data() {
    return {
      keywords: '',
      currLayout: '',
      allLayoutList: [],
      filterLayoutList: [],

      isExpand: true
    }
  },
  props: {
    cadInfo: Object,
    limitDragArea: String,
    closePanel: Function
  },
  components: {
    DragPanel
  },
  mounted() {
    this.initCadLayoutList()

    this.$nextTick(() => {
      let dataType = this.$route.query.dataType
      if (dataType === 'Cad') {
        let dom = this.$refs.dragPanel.$el
        if (dom) {
          dom.style.left = '10px'
        }
      }
    })
  },
  methods: {
    initCadLayoutList() {
      const BlackHole3D = window.BlackHole3D
      let layoutList = BlackHole3D.CAD.getAllLayoutId()
      this.allLayoutList = layoutList
      this.filterLayoutList = layoutList
      let currLayout = BlackHole3D.CAD.getCurLayoutId()
      this.currLayout = currLayout
    },
    switchLayout(layout) {
      const BlackHole3D = window.BlackHole3D
      this.currLayout = layout
      BlackHole3D.CAD.setCurShowLayout(layout)
    },
    search() {
      let layoutList = this.allLayoutList.filter(el =>
        el.includes(this.keywords)
      )
      this.filterLayoutList = layoutList
    },
    toggleExpand() {
      this.isExpand = !this.isExpand
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.dragPanel-layout {
  left: calc(50% + 10px);
}
.common-drag-panel {
  top: 60px;
  width: 290px;
  height: calc(100% - 125px);

  :deep(.content) {
    height: calc(100% - 40px);
    padding: 15px;

    .layout-box {
      display: flex;
      flex-direction: column;
      height: 100%;
      text-align: left;

      .layout-list-box {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        font-size: 14px;
        overflow: hidden;

        .cad-name-box {
          display: flex;
          align-items: center;
          height: 24px;

          .expand-icon-box {
            padding: 0px 5px;
            transform: rotate(0deg);
            cursor: pointer;
            transition: transform 0.3s ease-in-out;
          }

          .expand {
            transform: rotate(90deg);
          }

          .name-box {
            margin-left: 0px;
            font-size: 14px;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .list-box {
          margin-left: 10px;
          .list-item-box {
            margin: 2px 0px;
            cursor: pointer;
            padding-left: 12px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;

            &:hover {
              background-color: var(--base-bg-dark-color33);
            }
          }

          .active {
            color: var(--base-primary-bgColor);
            background-color: var(--base-bg-light-color24) !important;
          }
        }
      }
    }
  }
}
</style>
